export default "__VITE_ASSET__8571cf25__"